import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();

const baseUrl = '/api/badges';

export const fetchAllBadges = async () => {
    try {
        const response = await axios.get(`${baseUrl}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error fetching badges', 'error');
        return false;
    }
}

export const fetchBadgeById = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}/${id}`);
        addToast('Error fetching badge', 'error');
        return false;
    }
}

export const createBadge = async (badge) => {
    try {
        const response = await axios.post(`${baseUrl}`, badge);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`);
        addToast(error.response.data.message, 'error');
        return false;
    }
}

export const updateBadge = async (id, badge) => {
    try {
        const response = await axios.post(`${baseUrl}/update/${id}`, badge);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}/${id}`);
        addToast(error.response.data.message, 'error');
        return false;
    }
}

export const deleteBadge = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/delete/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}/delete/${id}`);
        addToast(error.response.data.message, 'error');
        return false;
    }
}

export const fetchBadgeCategories = async () => {
    try {
        const response = await axios.get(`${baseUrl}/badge-categories`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}/badge-categories`);
        addToast(error.response.data.message, 'error');
        return false;
    }
}
